import React from "react";

const Likeicon = ({ colorChange }) => {
  return (
    <div>
      <svg
        fill={colorChange}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        className="lovesvg"
        viewBox="0 0 24 24"
      >
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path>
      </svg>
    </div>
  );
};

export default Likeicon;
